<template>
   <div class="my-footer">
      Application développée par
      <a
         href="https://www.stephanealetru.fr"
         target="_blank"
      >&nbsp;Stéphane Alétru</a>
      &copy; {{ date }} Tous droits reservés
   </div>
</template>

<script>
export default {
   name: "Footer",
   data() {
      return {
         date: new Date().getFullYear()
      };
   }
};
</script>

<style>
</style>
